import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
//actions
import { actions } from "actions/resources";
//components
import ForgotPasswordForm from "./forms/forgot-password";

export class AuthForgotPassword extends Component {
  handleSubmit = async data => {
    const { createForgotPassword, redirect } = this.props;
    const response = await createForgotPassword({
      email: data.email
    });
    if (response) {
      redirect("/");
    }
  };

  render() {
    return (
      <div className="auth-form">
        <ForgotPasswordForm onSubmit={this.handleSubmit} />
      </div>
    );
  }
}

export default connect(
  null,
  dispatch => ({
    createForgotPassword: bindActionCreators(
      actions.createForgot_password,
      dispatch
    ),
    redirect: bindActionCreators(push, dispatch)
  })
)(AuthForgotPassword);



// WEBPACK FOOTER //
// ./src/components/auth/forgot-password.js